const childrenLoaded = require('@alexspirgel/children-loaded')
const extend = require('@alexspirgel/extend')
const transitionAuto = require('@alexspirgel/transition-auto')

class ComponentArticleList extends HTMLDivElement {
  async connectedCallback () {
    await childrenLoaded(this)
    // Prevents overlay loading in admin edit form page
    if (document.querySelector('body.gin--edit-form.user-logged-in')) {
      Array.from(
        document.querySelectorAll('a.component-article-list__article')
      ).forEach(function (item) {

        item.replaceWith(item.cloneNode(true))
      })
      return
    }
  }
}

customElements.define('component-article-list', ComponentArticleList, {
  extends: 'div'
})
